/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { colors, font, spacing } from '@chegg-ui/theme';
import styled from 'styled-components';
export var Input = styled.input.withConfig({
  componentId: "x1cbn6-0"
})(["border:0;height:", ";margin:0;opacity:0;position:absolute;width:", ";z-index:2;&:not(:disabled):hover{cursor:pointer;}"], function (_ref) {
  var inputSize = _ref.inputSize;
  return inputSize === 'large' ? '1.5rem' : '1.25rem';
}, function (_ref2) {
  var inputSize = _ref2.inputSize;
  return inputSize === 'large' ? '1.5rem' : '1.25rem';
});
export var StyledSVG = styled.svg.withConfig({
  componentId: "x1cbn6-1"
})(["", ":focus + &{box-shadow:0 0 0.125em 0.125em #7aacfe;outline:0.125em solid transparent;}", ":disabled + &{opacity:0.5;}flex-shrink:0;height:", ";width:", ";"], Input, Input, function (_ref3) {
  var size = _ref3.size;
  return size === 'large' ? '1.5rem' : '1.25rem';
}, function (_ref4) {
  var size = _ref4.size;
  return size === 'large' ? '1.5rem' : '1.25rem';
});
export var Group = styled.g.withConfig({
  componentId: "x1cbn6-2"
})(["fill:none;stroke:none;stroke-width:1;"]);
export var FauxInputContainer = styled.rect.withConfig({
  componentId: "x1cbn6-3"
})(["fill:", ";stroke:", ";stroke-width:2;", ":checked + ", " &,", ":checked:hover + ", " &{fill:", ";stroke:", ";}", ":not(:disabled):hover + ", " &{stroke:", ";}"], colors.white, colors.grey, Input, StyledSVG, Input, StyledSVG, colors.cheggOrange, colors.cheggOrange, Input, StyledSVG, colors.cheggOrange);
export var FauxInputCheck = styled.path.withConfig({
  componentId: "x1cbn6-4"
})(["fill:", ";"], colors.white);
export var StandaloneCheckboxContainer = styled.span.withConfig({
  componentId: "x1cbn6-5"
})(["display:inline-block;height:", ";position:relative;width:", ";"], function (_ref5) {
  var size = _ref5.size;
  return size === 'large' ? '1.5rem' : '1.25rem';
}, function (_ref6) {
  var size = _ref6.size;
  return size === 'large' ? '1.5rem' : '1.25rem';
});
export var Label = styled.label.withConfig({
  componentId: "x1cbn6-6"
})(["font-family:", ";padding-left:", ";", ":disabled ~ &{opacity:0.5;}", ":not(:disabled) ~ &{cursor:pointer;}"], font.family["default"], spacing.px12, Input, Input);
export var CheckboxContainer = styled.div.withConfig({
  componentId: "x1cbn6-7"
})(["display:flex;position:relative;font-size:", ";line-height:", ";align-items:", ";", " ", ""], font.size.px16, font.lineHeight.md, function (_ref7) {
  var align = _ref7.align;
  return align === 'middle' ? 'center' : 'flex-start';
}, function (_ref8) {
  var align = _ref8.align,
      size = _ref8.size;
  return align === 'top' && size === 'small' ? "\n        & > ".concat(Input, " {\n          top: 2px;\n        }\n\n        & > ").concat(StyledSVG, " {\n          margin-top: 2px;\n        }\n      ") : '';
}, function (_ref9) {
  var align = _ref9.align,
      size = _ref9.size;

  if (align === 'middle') {
    var halfCheckboxSize = size === 'large' ? '0.75rem' : '0.625rem';
    return "& > ".concat(Input, " { top: calc(50% - ").concat(halfCheckboxSize, "); }");
  }

  return '';
});